import { EventMeta } from '../../../interfaces/meta.interface';

const sendOnBehalf: EventMeta = {
    title: 'Send On Behalf Of',
    default: {
        description: 'Send On Behalf Of',
        longDescription:
            "An item that's labeled as a record was soft-deleted (moved to the Recoverable Items folder). Items labeled as records can't be permanently deleted.",
        severity: 'info',
    },
};

export default sendOnBehalf;
